import { render, staticRenderFns } from "./BaseTabPanel.vue?vue&type=template&id=4e04bc1c&scoped=true&"
import script from "./BaseTabPanel.vue?vue&type=script&lang=js&"
export * from "./BaseTabPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabPanel.vue?vue&type=style&index=0&id=4e04bc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04bc1c",
  null
  
)

export default component.exports